module.exports = __webpack_public_path__ + "static/media/Calcolodelpercorso.a644fafd.svg";